import React from "react";
import FilterItem from "./FilterItem";
import SelectedFilter from "./SelectedFilter";
import {
  Button,
  Popover,
  Menu,
  MenuItem,
  Position,
  PopoverInteractionKind
} from "@blueprintjs/core";
import classNames from "classnames";
import styles from "./FilterToolbar.module.scss";

function FilterToolbar({ value, onChange, filterOptions }) {
  return (
    <div className={styles.filterToolbar}>
      <div className={styles.selectedFilters}>
        {Object.keys(value).map((filterKey) => {
          const matchingSelection = value[filterKey];
          const matchingFilter = filterOptions.find((f) => f.key === filterKey);

          if (!matchingFilter) {
            throw new Error(`Invalid filter selected: ${filterKey}`);
          }

          return (
            <SelectedFilter
              key={filterKey}
              selection={matchingSelection}
              filter={matchingFilter}
              value={value}
              onChange={onChange}
            />
          );
        })}
      </div>

      <Popover position={Position.BOTTOM_RIGHT}>
        <Button
          text="Filter"
          icon="settings"
          className={classNames(styles.filterButton, "bold")}
          minimal
        />
        <Menu>
          {filterOptions.map((filter) => (
            <MenuItem
              key={filter.key}
              text={`By ${filter.label}`}
              popoverProps={{ interactionKind: PopoverInteractionKind.CLICK }}
            >
              <FilterItem
                filter={filter}
                filters={value}
                onAddFilter={(selection) =>
                  onChange({ ...value, [filter.key]: selection })
                }
              />
            </MenuItem>
          ))}
        </Menu>
      </Popover>
    </div>
  );
}

export default FilterToolbar;
